import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[alert-data-ctrl]'
})
export class AlertDataCtrlDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}